import { mapWhenDefined } from '@essent/core-utils';
import { createSelector } from '@ngrx/store';
import type { ConsentType } from '@integration/api-client/consent';

import { getConsent } from '../../utils/get-consent.utils';
import { selectConsentAreYouSureConsent } from '../consent-rendering/consent-rendering.selectors';
import { selectConsentState } from '../consent.state';
import { selectGetConsentsData } from '../get-consents';

export const selectConsentForm = createSelector(
  selectConsentState,
  (state) => state.consentForm
);

export const selectTotalConsentsInForm = createSelector(
  selectConsentForm,
  (form) => Object.keys(form.value.consents).length
);

export const selectGivenConsentsInForm = createSelector(
  selectConsentForm,
  (form) =>
    Object.values(form.value.consents).filter((value) => value === true).length
);

export const selectShowAreYouSureModal = createSelector(
  selectGetConsentsData,
  selectConsentForm,
  selectConsentAreYouSureConsent,
  (data, form, consentType) =>
    mapWhenDefined(data, (consentGroups) => {
      const consent = getConsent(consentGroups, consentType as ConsentType);
      return consent && form.value.consents[consent.version_id] === false;
    })
);
